import { CanActivate } from '@angular/router';
import { AuthenticationFacade } from '../+state';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class LocationTokenGuard implements CanActivate {
  constructor(private authenticationFacade: AuthenticationFacade) {}

  public canActivate(): Observable<boolean> {
    return this.authenticationFacade.getLocationToken().pipe(
      filter((authToken) => !!authToken),
      map((authToken) => !!authToken)
    );
  }
}
